import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';

interface MDeleteButtonProps {
  onClick?: () => void;
  className?: string;
}

export const MDeleteButton = ({ onClick, className }: MDeleteButtonProps) => {
  return (
    <Button
      variant='text'
      color='error'
      startIcon={<DeleteIcon fontSize='small' />}
      onClick={onClick}
      className={className}>
      Delete
    </Button>
  );
};
